module.exports = __webpack_public_path__ + "media/images/top/reserved_order_ov-cb979ec279fa8d9241d2ceddad6cacfd.png";